var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.359375,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E9F8F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 46.3594C43.3137 46.3594 46 43.6731 46 40.3594C46 37.0457 43.3137 34.3594 40 34.3594C36.6863 34.3594 34 37.0457 34 40.3594C34 43.6731 36.6863 46.3594 40 46.3594Z",
    fill: "#179D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0162 38.7281C59.5355 34.8919 56.3171 31.6331 52.7096 29.3034C48.7187 26.7234 44.3124 25.3594 39.968 25.3594C35.9818 25.3594 32.0621 26.4984 28.3177 28.7447C24.4993 31.035 21.0399 34.3809 18.0352 38.6887C17.696 39.1756 17.5092 39.7523 17.4985 40.3456C17.4878 40.9388 17.6538 41.5219 17.9752 42.0206C20.4512 45.8953 23.6377 49.1587 27.189 51.4566C31.1874 54.0469 35.4905 55.3594 39.968 55.3594C44.3471 55.3594 48.7627 54.0066 52.7368 51.4481C56.3424 49.1259 59.5543 45.855 62.0255 41.9869C62.3359 41.4997 62.5 40.9337 62.4983 40.3561C62.4967 39.7785 62.3293 39.2135 62.0162 38.7281ZM39.9999 49.3594C38.2199 49.3594 36.4798 48.8315 34.9998 47.8426C33.5197 46.8537 32.3662 45.4481 31.685 43.8035C31.0038 42.159 30.8256 40.3494 31.1728 38.6036C31.5201 36.8577 32.3773 35.2541 33.636 33.9954C34.8946 32.7367 36.4983 31.8796 38.2441 31.5323C39.9899 31.185 41.7995 31.3633 43.4441 32.0445C45.0886 32.7256 46.4942 33.8792 47.4831 35.3592C48.4721 36.8393 48.9999 38.5793 48.9999 40.3594C48.9972 42.7455 48.0481 45.0331 46.3609 46.7203C44.6736 48.4076 42.386 49.3566 39.9999 49.3594Z",
    fill: "#179D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.a3ebdbafc41a88b9a28780fda02f5223.svg";
export { ForwardRef as ReactComponent };